var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "scrollableDiv", staticClass: "form-post-creator hide-scrollbar" },
    [
      _vm.isPrenium && !_vm.lockedValue.active
        ? _c("section", { staticClass: "publish-date" }, [
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("dash.post-creator.form.publish-date")) +
                  " \n            "
              ),
              _vm.draftInstance.form.planifiedDate.isEdited()
                ? _c(
                    "span",
                    {
                      staticClass: "restore",
                      on: {
                        click: _vm.draftInstance.form.planifiedDate.restore,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.cancel-changes")
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "content-section" },
              [
                _c("SelectComponent", {
                  attrs: {
                    changeValueSelect: _vm.changeSelectPublishDate,
                    data: {
                      now: _vm.$t("dash.post-creator.form.now"),
                      flanified: _vm.$t("dash.button.schedule"),
                    },
                    valueSelect: !_vm.draftInstance.form.planifiedDate.date
                      ? "now"
                      : "flanified",
                    positionAuto: false,
                    positionX: "left",
                  },
                }),
                _vm.draftInstance.form.planifiedDate.date
                  ? [
                      _c("div", { staticClass: "input-date" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.draftInstance.form.planifiedDate
                                .dayDynamicLabel
                            )
                          ),
                        ]),
                        _c("i", { staticClass: "fa-regular fa-calendar" }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.models.date,
                              expression: "models.date",
                            },
                          ],
                          attrs: {
                            type: "date",
                            disabled:
                              !_vm.draftInstance.form.planifiedDate.date,
                            min: new Date()
                              .toLocaleString("fr-FR")
                              .split(" ")[0]
                              .split("/")
                              .reverse()
                              .join("-"),
                          },
                          domProps: { value: _vm.models.date },
                          on: {
                            click: (e) => e.target.showPicker(),
                            change: _vm.setDate,
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.models, "date", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "input-hours" },
                        [
                          _c("VueTimepicker", {
                            attrs: { "manual-input": "" },
                            on: { close: _vm.setDate },
                            model: {
                              value: _vm.models.hours,
                              callback: function ($$v) {
                                _vm.$set(_vm.models, "hours", $$v)
                              },
                              expression: "models.hours",
                            },
                          }),
                          _c("i", { staticClass: "fa-regular fa-clock" }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
      _c(
        "section",
        {
          staticClass: "content-post",
          class: {
            lockedField:
              _vm.lockedValue.active &&
              !_vm.lockedValue.fieldsEditable.textContent,
          },
        },
        [
          _c("label", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.content")) +
                " \n            "
            ),
            _vm.draftInstance.form.textContent.isEdited() &&
            (!_vm.lockedValue.active ||
              _vm.lockedValue.fieldsEditable.textContent)
              ? _c(
                  "span",
                  {
                    staticClass: "restore",
                    on: { click: _vm.draftInstance.form.textContent.restore },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("dash.post-creator.form.cancel-changes")
                        ) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _c("Editor", {
            attrs: {
              id: "contentPost",
              mentions: _vm.draftInstance.form.mentions.items,
              text: _vm.draftInstance.form.textContent.value,
              maxCharacters: _vm.maxCharactersText,
              textInfoMaxCharacters: _vm.textInfoMaxCharacters,
              pickerStyle: "transform: translate(100%, -50%)",
              typeRenderNetworkSelected: _vm.typeRenderNetworkSelected,
              personalizationMode: _vm.personalizationMode,
            },
            on: {
              setMention: _vm.draftInstance.form.mentions.add,
              setText: _vm.draftInstance.form.textContent.setValue,
            },
          }),
        ],
        1
      ),
      _c(
        "section",
        {
          staticClass: "content-media",
          class: {
            lockedField:
              _vm.lockedValue.active && !_vm.lockedValue.fieldsEditable.medias,
          },
        },
        [
          _c("label", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("dash.post-creator.form.media")) +
                "\n            "
            ),
            _c("i", {
              staticClass: "fa-solid fa-circle-question",
              on: { click: _vm.showTableMedia },
            }),
            _vm.draftInstance.form.medias.isEdited() &&
            (!_vm.lockedValue.active || _vm.lockedValue.fieldsEditable.medias)
              ? _c(
                  "span",
                  {
                    staticClass: "restore",
                    on: { click: _vm.draftInstance.form.medias.restore },
                  },
                  [
                    _vm._v(
                      "\n               " +
                        _vm._s(
                          _vm.$t("dash.post-creator.form.cancel-changes")
                        ) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "container-medias", class: { wrap: true } },
            [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "",
                    expression: "''",
                  },
                ],
                ref: "inputMediaPostCreator",
                attrs: {
                  name: "file",
                  type: "file",
                  id: "file",
                  multiple: true,
                  accept:
                    this.acceptedFileTypesPerNetwork[
                      this.personalizationMode && this.typeRenderNetworkSelected
                        ? this.typeRenderNetworkSelected
                        : "default"
                    ].join(", "),
                  hidden: "",
                },
                on: { change: _vm.selectFiles, click: () => {} },
              }),
              !_vm.thumbnailSelector.fileIdVideo
                ? _c("DropFile", {
                    attrs: { targetInput: _vm.$refs.inputMediaPostCreator },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "btn-add-media",
                  on: { click: _vm.clickBtnAddMedia },
                },
                [_c("i", { staticClass: "fa-solid fa-photo-film" })]
              ),
              _c(
                "draggable",
                _vm._b(
                  {
                    ref: "listMedia",
                    staticClass: "list-media hide-scrollbar",
                    attrs: { move: _vm.moveFileMedia },
                    on: {
                      start: function ($event) {
                        _vm.drag = true
                      },
                      end: _vm.endMoveFileMedia,
                    },
                    model: {
                      value: _vm.draftInstance.form.medias.items,
                      callback: function ($$v) {
                        _vm.$set(_vm.draftInstance.form.medias, "items", $$v)
                      },
                      expression: "draftInstance.form.medias.items",
                    },
                  },
                  "draggable",
                  _vm.dragOptions,
                  false
                ),
                [
                  _c(
                    "transition-group",
                    {
                      attrs: {
                        type: "transition",
                        name: !_vm.drag ? "flip-list" : null,
                      },
                    },
                    [
                      _vm._l(_vm.draftInstance.form.medias, function (media) {
                        return media.file &&
                          (!_vm.personalizationMode ||
                            !_vm.typeRenderNetworkSelected ||
                            _vm.acceptedFileTypesPerNetwork[
                              _vm.typeRenderNetworkSelected
                            ].includes(media.file.info.type))
                          ? [
                              _c(
                                "Tooltip",
                                {
                                  key: media.fileId,
                                  attrs: {
                                    active:
                                      !media.file ||
                                      (!media.file.isUpload &&
                                        !media.file.isUploading) ||
                                      (!_vm.personalizationMode &&
                                        !media.file.isUploading &&
                                        Object.keys(media.file.errorNetworks)
                                          .length &&
                                        Object.keys(
                                          media.file.errorNetworks
                                        ).some((networkName) =>
                                          _vm.networksSelected.includes(
                                            networkName
                                          )
                                        )) ||
                                      (_vm.personalizationMode &&
                                        !media.file.isUploading &&
                                        _vm.typeRenderNetworkSelected &&
                                        media.file.errorNetworks.hasOwnProperty(
                                          _vm.typeRenderNetworkSelected
                                        )),
                                    text:
                                      !media.file ||
                                      (!media.file.isUpload &&
                                        !media.file.isUploading)
                                        ? "Echec du chargement du media"
                                        : _vm.personalizationMode &&
                                          _vm.typeRenderNetworkSelected &&
                                          !media.file.isUploading &&
                                          media.file.errorNetworks[
                                            _vm.typeRenderNetworkSelected
                                          ]
                                        ? `<b>${
                                            _vm.typeRenderNetworkSelected
                                              .charAt(0)
                                              .toUpperCase() +
                                            _vm.typeRenderNetworkSelected.slice(
                                              1
                                            )
                                          } :</b><br>${Object.values(
                                            media.file.errorNetworks[
                                              _vm.typeRenderNetworkSelected
                                            ]
                                          ).join("<br>")}`
                                        : !_vm.personalizationMode &&
                                          !media.file.isUploading &&
                                          Object.keys(media.file.errorNetworks)
                                            .length &&
                                          Object.keys(
                                            media.file.errorNetworks
                                          ).some((networkName) =>
                                            _vm.networksSelected.includes(
                                              networkName
                                            )
                                          )
                                        ? Object.keys(media.file.errorNetworks)
                                            .reduce((newArray, networkName) => {
                                              if (
                                                _vm.networksSelected.includes(
                                                  networkName
                                                )
                                              )
                                                newArray.push(
                                                  `<b>${
                                                    networkName
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    networkName.slice(1)
                                                  } :</b><br>${Object.values(
                                                    media.file.errorNetworks[
                                                      networkName
                                                    ]
                                                  ).join("<br>")}`
                                                )
                                              return newArray
                                            }, [])
                                            .join("<br><br>")
                                        : "",
                                    position: "bottom",
                                    classCustom: "item-draggable",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-circle-xmark",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeMedia(media.fileId)
                                      },
                                    },
                                  }),
                                  media.file.info.type.startsWith("image/")
                                    ? _c(
                                        "div",
                                        {
                                          key: `image${media.fileId}`,
                                          staticClass:
                                            "media-container picture",
                                          class: media.file.info.type,
                                          on: {
                                            click: function ($event) {
                                              return _vm.startEditImage(media)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "media picture",
                                              attrs: { media: media.fileId },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "source",
                                                attrs: {
                                                  draggable: "false",
                                                  src: media.file.url,
                                                  alt: "",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : media.file.info.type.startsWith("video/")
                                    ? _c(
                                        "div",
                                        {
                                          key: `video${media.fileId}`,
                                          staticClass: "media-container video",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "media video",
                                              attrs: { media: media.fileId },
                                            },
                                            [
                                              _c("video", {
                                                key: media.file.url,
                                                staticClass: "source",
                                                attrs: {
                                                  muted: "",
                                                  loop: "",
                                                  playsinline: "",
                                                  preload: "metadata",
                                                  onloadedmetadata:
                                                    "this.muted = true",
                                                  src: media.file.url,
                                                  type: media.file.info.type,
                                                },
                                                domProps: { muted: true },
                                              }),
                                              media.imagePreview &&
                                              media.imagePreview.fileId
                                                ? _c("img", {
                                                    staticClass: "preview",
                                                    attrs: {
                                                      type: media.imagePreview
                                                        .file.info.type,
                                                      src: media.imagePreview
                                                        .file.url,
                                                      alt: "",
                                                      draggable: "false",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.clickBtnAddVideoPreview(
                                                          media
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _c("video", {
                                                    key: media.file.url,
                                                    staticClass: "preview",
                                                    attrs: {
                                                      muted: "",
                                                      playsinline: "",
                                                      preload: "metadata",
                                                      onloadedmetadata:
                                                        "this.muted = true",
                                                      src: media.file.url,
                                                      type: media.file.info
                                                        .type,
                                                    },
                                                    domProps: { muted: true },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.clickBtnAddVideoPreview(
                                                          media
                                                        )
                                                      },
                                                    },
                                                  }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : ["application/pdf"].includes(
                                        media.file.info.type
                                      )
                                    ? _c(
                                        "div",
                                        {
                                          key: `pdf${media.fileId}`,
                                          staticClass: "media-container pdf",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "media pdf",
                                              attrs: { media: media.fileId },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "container-svg",
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "100%",
                                                        height: "100%",
                                                        viewBox: "0 0 36 44",
                                                        fill: "none",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M4.31826 0H25.0017C25.2296 0.0296647 25.4589 0.0524506 25.6853 0.0904987C26.6275 0.249355 27.4586 0.654342 28.1394 1.31148C30.3569 3.45192 32.5639 5.60247 34.7602 7.76311C35.2913 8.28289 35.6901 8.88994 35.8815 9.61694C35.9883 10.0221 36.0002 10.4353 36 10.8519C35.9978 20.3622 35.996 29.8725 35.9946 39.3828C35.9974 39.7155 35.966 40.0475 35.9007 40.3738C35.6321 41.6494 34.9343 42.6408 33.8246 43.3332C33.1277 43.773 32.3182 44.0044 31.4927 43.9996C22.4808 43.9967 13.4688 43.9967 4.45688 43.9996C3.95217 43.9991 3.45185 43.9064 2.98092 43.7259C1.15872 43.0374 0 41.3676 0 39.4293C0 27.8178 0.00115338 16.2056 0.00346015 4.59286C0.00461999 4.29972 0.0317573 4.00724 0.0845573 3.71883C0.424084 1.84136 1.95498 0.357481 3.8399 0.0659931C3.99885 0.0414875 4.15866 0.0214961 4.31826 0ZM34.508 25.0961C34.508 20.3765 34.508 15.657 34.508 10.9374C34.508 10.7655 34.5067 10.5935 34.492 10.4226C34.4659 10.1189 34.4224 9.81836 34.2641 9.54751C34.102 9.26419 33.9023 9.00389 33.6702 8.77365C31.7438 6.89417 29.8174 5.01576 27.8911 3.13844C27.6007 2.85512 27.3187 2.56169 27.0123 2.29643C26.3395 1.71432 25.5344 1.48861 24.657 1.48861C17.9789 1.4876 11.3008 1.4876 4.62254 1.48861C3.77913 1.48861 3.03822 1.75645 2.42859 2.34222C1.77332 2.97034 1.49024 3.75215 1.49046 4.65069C1.4919 16.2241 1.49269 27.7974 1.49284 39.3706C1.49123 39.5459 1.50243 39.7212 1.52636 39.8949C1.67774 40.9205 2.21363 41.6847 3.12927 42.1795C3.61088 42.4398 4.13293 42.5303 4.67941 42.5301C13.5296 42.5275 22.3799 42.5269 31.2302 42.5282C31.331 42.5282 31.432 42.5282 31.533 42.5252C32.4668 42.4886 33.2371 42.1167 33.8283 41.3966C34.3078 40.813 34.5082 40.132 34.508 39.3837C34.5062 34.621 34.5058 29.8585 34.5069 25.0961H34.508Z",
                                                          fill: "#fff",
                                                        },
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M18.7277 11.049C18.7127 12.0105 18.5568 12.9146 18.3295 13.808C18.1805 14.3934 18.0268 14.9774 17.8719 15.5615C17.8626 15.5933 17.8602 15.6268 17.8648 15.6597C17.8694 15.6926 17.8809 15.7242 17.8985 15.7523C18.5004 16.8231 19.2651 17.7777 20.0347 18.7291C20.222 18.9606 20.4106 19.1913 20.597 19.4243C20.6349 19.4718 20.6703 19.486 20.7337 19.4778C21.3721 19.3955 22.0096 19.3059 22.6504 19.2414C23.497 19.1554 24.3463 19.1238 25.1938 19.2358C25.681 19.3003 26.1572 19.4078 26.588 19.6584C27.0839 19.946 27.3733 20.3596 27.3824 20.9467C27.3882 21.3336 27.2269 21.6311 26.9137 21.8495C26.6079 22.0645 26.2574 22.1539 25.8921 22.1909C24.919 22.2893 23.9962 22.0722 23.1024 21.7117C22.1762 21.337 21.3292 20.7923 20.6059 20.106C20.5282 20.0327 20.4619 20.0157 20.3587 20.0374C19.299 20.2594 18.2394 20.4757 17.2052 20.7958C16.6429 20.9699 16.0841 21.1584 15.5253 21.3448C15.4767 21.3648 15.4355 21.3994 15.4074 21.4437C14.9927 22.067 14.5908 22.7003 14.1657 23.317C13.5677 24.1842 12.9114 25.0045 12.1075 25.6969C11.5965 26.1369 11.0167 26.4374 10.3427 26.5419C10.0506 26.5908 9.75106 26.5724 9.46724 26.4882C9.00423 26.3476 8.56284 25.8407 8.62383 25.2878C8.6554 25.0017 8.78062 24.7549 8.94649 24.5256C9.25098 24.1045 9.645 23.7758 10.0622 23.4723C10.8269 22.9172 11.6649 22.4882 12.5109 22.0731C12.9849 21.8405 13.4589 21.6077 13.9304 21.3699C13.9862 21.3409 14.0315 21.2954 14.0601 21.2397C15.0296 19.1898 15.9146 17.1017 16.6948 14.9705C16.7168 14.9012 16.7168 14.8268 16.6948 14.7575C16.4909 14.1176 16.2517 13.4871 16.0787 12.8392C15.8438 11.9554 15.7439 11.0415 15.7822 10.1281C15.7899 9.88861 15.8224 9.65054 15.8791 9.41765C16.0804 8.62229 16.8538 8.26589 17.6031 8.61198C18.1319 8.85617 18.4217 9.29211 18.5776 9.83167C18.6959 10.2412 18.7186 10.6621 18.7277 11.049ZM17.5832 16.1831C17.0742 17.748 16.444 19.2399 15.7855 20.7403C17.2128 20.239 18.6688 19.8751 20.1881 19.6036C19.2251 18.5157 18.3509 17.4041 17.5832 16.1831ZM21.0079 19.8914C21.0451 19.9213 21.0609 19.9344 21.0775 19.9473C22.0291 20.652 23.1 21.1161 24.2237 21.4701C24.5161 21.5623 24.8138 21.6296 25.124 21.6165C25.5712 21.5978 25.9483 21.2994 26.0348 20.8964C26.1183 20.5094 25.9124 20.1057 25.5067 19.9136C25.31 19.8186 25.1024 19.7477 24.8885 19.7023C24.3595 19.5948 23.8193 19.6019 23.2853 19.6378C22.6292 19.6818 21.9763 19.7704 21.3221 19.8413C21.2242 19.8517 21.1281 19.8721 21.0079 19.8914ZM13.4959 22.1195L13.4758 22.1008C13.3158 22.181 13.1553 22.2605 12.9955 22.3409C12.223 22.7304 11.4374 23.0959 10.7051 23.56C10.2306 23.8609 9.77281 24.1833 9.39847 24.6068C9.2553 24.7691 9.1316 24.9445 9.06802 25.1545C8.91664 25.6556 9.34484 26.1126 9.85521 25.983C10.3076 25.8682 10.691 25.6225 11.0254 25.3035C11.8165 24.5486 12.4719 23.684 13.0749 22.7777C13.2191 22.561 13.3558 22.3394 13.4959 22.1195ZM16.9487 14.1055C16.9658 14.0937 16.9747 14.0911 16.9768 14.0858C16.9846 14.066 16.9905 14.0451 16.9967 14.0247C17.3354 12.9297 17.6059 11.8192 17.7091 10.6756C17.7372 10.3646 17.7193 10.0466 17.6918 9.73429C17.679 9.58768 17.6289 9.41787 17.5356 9.30931C17.1784 8.89293 16.7095 8.90991 16.4375 9.41679C16.4241 9.44216 16.4105 9.46731 16.399 9.49353C16.2861 9.74912 16.2374 10.0189 16.2232 10.2956C16.1951 10.8315 16.2772 11.3583 16.3529 11.8863C16.4611 12.6483 16.7102 13.3706 16.9487 14.1055Z",
                                                          fill: "#fff",
                                                        },
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M15.7803 37.7018V30.9759C15.8058 30.9716 15.8316 30.9687 15.8575 30.9673C16.4732 30.972 17.0902 30.9608 17.7041 30.9871C18.3109 31.0131 18.8829 31.17 19.365 31.5657C19.794 31.9176 20.057 32.3776 20.2106 32.8985C20.536 34.0053 20.4904 35.1014 20.0239 36.1595C19.7229 36.8422 19.2253 37.3437 18.4846 37.5653C18.1697 37.6562 17.8435 37.7026 17.5155 37.7029C16.961 37.7087 16.4063 37.7052 15.8519 37.7057C15.8304 37.7061 15.8099 37.7042 15.7803 37.7018ZM16.9014 36.8043C17.1438 36.8043 17.3752 36.8196 17.6038 36.8013C18.1745 36.7555 18.6156 36.4963 18.8812 35.9782C18.9428 35.8612 18.995 35.7395 19.0374 35.6143C19.28 34.8675 19.2785 34.1096 19.1297 33.3465C19.0583 32.981 18.9197 32.6397 18.6608 32.3605C18.1771 31.8381 17.5447 31.8398 16.9014 31.8682V36.8043Z",
                                                          fill: "#fff",
                                                        },
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M11.8611 35.0744V37.701H10.7495C10.7478 37.6638 10.7446 37.6264 10.7446 37.5888C10.7446 35.4228 10.7438 33.2569 10.7422 31.0909C10.7422 30.9923 10.7686 30.9643 10.8683 30.9656C11.5343 30.9749 12.2009 30.9656 12.8663 30.9888C13.15 31.0017 13.4314 31.0458 13.7054 31.1204C14.1967 31.2494 14.5137 31.5976 14.7088 32.0432C15.0021 32.713 14.9986 33.3975 14.6902 34.0613C14.4179 34.6477 13.9257 34.9544 13.2906 35.0163C12.8652 35.0578 12.4357 35.0568 12.0082 35.0742C11.9625 35.0759 11.9169 35.0744 11.8611 35.0744ZM11.8695 34.184C12.291 34.1769 12.7086 34.2186 13.1154 34.0948C13.3349 34.0282 13.5153 33.9044 13.605 33.6896C13.7914 33.2442 13.8038 32.7906 13.6007 32.3485C13.4861 32.0991 13.3014 31.8953 13.0069 31.8728C12.6349 31.8444 12.2608 31.8467 11.8875 31.8364C11.8819 31.8364 11.876 31.8442 11.8695 31.8489V34.184Z",
                                                          fill: "#fff",
                                                        },
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M24.7185 33.8796V34.761H22.6149V37.6978H21.501V30.9727C21.5421 30.971 21.5771 30.968 21.6124 30.968C22.7862 30.968 23.9601 30.9673 25.1341 30.9658C25.2263 30.9658 25.2598 30.9852 25.2572 31.0836C25.25 31.3371 25.2548 31.5909 25.2548 31.8575H22.6164C22.6138 31.9026 22.6102 31.9366 22.6102 31.9708C22.6102 32.5686 22.6121 33.1664 22.6078 33.7642C22.6078 33.8609 22.6368 33.8833 22.7302 33.8826C23.3459 33.8785 23.9616 33.8807 24.5775 33.8807L24.7185 33.8796Z",
                                                          fill: "#fff",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              media.file.info.enclosure
                                                ? _c("img", {
                                                    staticClass: "source",
                                                    attrs: {
                                                      draggable: "false",
                                                      src: media.file.info
                                                        .enclosure,
                                                      alt: "",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  media.file &&
                                  ((!media.file.isUpload &&
                                    media.file.isUploading) ||
                                    media.file.isNormalizing)
                                    ? _c(
                                        "div",
                                        { staticClass: "containerProgressBar" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "progressBar" },
                                            [
                                              media.file.isNormalizing
                                                ? _c("div", {
                                                    staticClass:
                                                      "bar normalizing-bar",
                                                  })
                                                : _c("div", {
                                                    staticClass: "bar",
                                                    style: {
                                                      width: `${parseInt(
                                                        media.file.percentUpload
                                                      )}%`,
                                                    },
                                                  }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("i", {
                                    staticClass:
                                      "fa-solid fa-circle-exclamation",
                                  }),
                                  media.file &&
                                  media.file.normalizedNetworks &&
                                  media.file.normalizedNetworks.length > 0 &&
                                  ((_vm.personalizationMode &&
                                    _vm.typeRenderNetworkSelected &&
                                    media.file.normalizedNetworks.includes(
                                      _vm.typeRenderNetworkSelected
                                    )) ||
                                    (!_vm.personalizationMode &&
                                      media.file.normalizedNetworks.some(
                                        (networkName) =>
                                          _vm.networksSelected.includes(
                                            networkName
                                          )
                                      )))
                                    ? _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            active: true,
                                            text:
                                              _vm.personalizationMode &&
                                              _vm.typeRenderNetworkSelected &&
                                              media.file.normalizedNetworks.includes(
                                                _vm.typeRenderNetworkSelected
                                              )
                                                ? `Image compressée pour <b>${
                                                    _vm.typeRenderNetworkSelected
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    _vm.typeRenderNetworkSelected.slice(
                                                      1
                                                    )
                                                  }</b>`
                                                : !_vm.personalizationMode
                                                ? `Image compressée pour <b>${media.file.normalizedNetworks
                                                    .filter((networkName) =>
                                                      _vm.networksSelected.includes(
                                                        networkName
                                                      )
                                                    )
                                                    .map(
                                                      (n) =>
                                                        n
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                        n.slice(1)
                                                    )
                                                    .join(", ")}</b>`
                                                : "",
                                            position: "bottom",
                                            classCustom:
                                              "icon-normalized warning-icon-normalized",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa-solid fa-triangle-exclamation",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  media.file.info.type.startsWith("image/")
                                    ? _c(
                                        "Tooltip",
                                        {
                                          key: `alt-text-${media.fileId}`,
                                          attrs: {
                                            active: true,
                                            text: _vm.$t(
                                              "dash.post-creator.alt-text.add"
                                            ),
                                            position: "bottom",
                                            classCustom: "alt-text-btn",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.addMode("inputMode", {
                                                    id: `alt_text-${media.fileId}`,
                                                    title: _vm.$t(
                                                      "dash.post-creator.alt-text.add"
                                                    ),
                                                    value: media.altTextValue,
                                                    placeholder: _vm.$t(
                                                      "dash.post-creator.form.alt-text.placeholder"
                                                    ),
                                                  })
                                                },
                                              },
                                            },
                                            [_vm._v("ALT")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  media.file.info.type2 == "pdf"
                                    ? _c(
                                        "Tooltip",
                                        {
                                          key: `title-pdf-${media.fileId}`,
                                          attrs: {
                                            text: _vm.$t(
                                              "dash.post-creator.form.pdf-title.edit"
                                            ),
                                            classCustom: "title-pdf-btn",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.addMode("inputMode", {
                                                    id: `pdf_title-${media.fileId}`,
                                                    title: _vm.$t(
                                                      "dash.post-creator.form.pdf-title.edit"
                                                    ),
                                                    value:
                                                      media.file.info
                                                        .customName,
                                                    placeholder:
                                                      media.file.info.name,
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.post-creator.form.pdf-title.label"
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "section",
        {
          staticClass: "comment-post",
          class: {
            disabled: _vm.typeRenderNetworkSelected === "tiktok",
            lockedField:
              _vm.lockedValue.active &&
              !_vm.lockedValue.fieldsEditable.comments,
          },
        },
        [
          _c(
            "label",
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("dash.post-creator.form.comment.label")) +
                  "\n            "
              ),
              _vm.typeRenderNetworkSelected === "tiktok"
                ? _c(
                    "Tooltip",
                    {
                      attrs: {
                        active: true,
                        text: _vm.$t(
                          "dash.post-creator.form.comment.tiktok-warning"
                        ),
                        position: "right",
                        classCustom: "warning-tooltip",
                      },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa-solid fa-circle-exclamation warning-icon",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm.draftInstance.form.comments.isEdited() &&
              (!_vm.lockedValue.active ||
                _vm.lockedValue.fieldsEditable.comments)
                ? _c(
                    "span",
                    {
                      staticClass: "restore",
                      on: { click: _vm.draftInstance.form.comments.restore },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.cancel-changes")
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "list-comment" },
            _vm._l(_vm.draftInstance.form.comments, function (comment, index) {
              return _c("Editor", {
                key: index,
                attrs: {
                  id: "contentCommentPost",
                  text: comment.value,
                  mentions: _vm.draftInstance.form.mentions.items,
                  compactOption: true,
                  showOptionBold: false,
                  showOptionItalic: false,
                  showOptionUnderline: false,
                  ShowCounterCharacters: false,
                  pickerStyle: "transform: translate(0%, -50%)",
                  typeRenderNetworkSelected: _vm.typeRenderNetworkSelected,
                  personalizationMode: _vm.personalizationMode,
                },
                on: {
                  setMention: _vm.draftInstance.form.mentions.add,
                  setText: comment.setValue,
                  onBlur: _vm.draftInstance.form.comments.clearEmpty,
                },
              })
            }),
            1
          ),
          _vm.draftInstance.form.comments[0] &&
          !_vm.draftInstance.form.comments[0].isEmpty
            ? _c(
                "p",
                {
                  staticClass: "btn-add-comment",
                  on: {
                    click: function ($event) {
                      return _vm.draftInstance.form.comments.add("")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dash.post-creator.form.comment.add")))]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "section",
        {
          staticClass: "settings-advanced",
          class: { lockedField: _vm.lockedValue.active },
        },
        [
          _c(
            "label",
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("dash.post-creator.form.settings.label")) +
                  " " +
                  _vm._s(_vm.typeRenderNetworkSelected || _vm.networkSetting) +
                  " \n            "
              ),
              !_vm.lockedValue.active
                ? [
                    _vm.draftInstance.form.networks[
                      _vm.typeRenderNetworkSelected
                    ] &&
                    _vm.draftInstance.form.networks[
                      _vm.typeRenderNetworkSelected
                    ].isEdited &&
                    _vm.draftInstance.form.networks[
                      _vm.typeRenderNetworkSelected
                    ].isEdited()
                      ? _c(
                          "span",
                          {
                            staticClass: "restore",
                            on: {
                              click:
                                _vm.draftInstance.form.networks[
                                  _vm.typeRenderNetworkSelected
                                ].restore,
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "dash.post-creator.form.cancel-changes"
                                  )
                                ) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.personalizationMode || _vm.idPageRenderNetworkSelected,
                  expression:
                    "!personalizationMode || idPageRenderNetworkSelected",
                },
              ],
              staticClass: "sub-label",
            },
            [_vm._v(_vm._s(_vm.$t("dash.post-creator.form.settings.subtitle")))]
          ),
          _vm.typeRenderNetworkSelected
            ? _c(
                `Form${_vm.typeRenderNetworkSelected
                  .charAt(0)
                  .toUpperCase()}${_vm.typeRenderNetworkSelected.slice(1)}`,
                {
                  key: _vm.network,
                  ref: "formNetwork",
                  tag: "component",
                  attrs: {
                    files: _vm.files,
                    personalizationMode: _vm.personalizationMode,
                    idPageRenderNetworkSelected:
                      _vm.idPageRenderNetworkSelected,
                    typeRenderNetworkSelected: _vm.typeRenderNetworkSelected,
                    maxCharactersText: _vm.maxCharactersText,
                    draftInstance: _vm.draftInstance,
                  },
                }
              )
            : _vm._e(),
        ],
        1
      ),
      true && _vm.imageCropperData.fileOrigin
        ? _c(
            "portal",
            { attrs: { to: "dash" } },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c("ImageCropper", {
                    attrs: {
                      src: _vm.imageCropperData.fileOrigin.url,
                      imageState: JSON.parse(_vm.imageCropperData.imageState),
                    },
                    on: {
                      finished: _vm.endEditImage,
                      clickOutside: function ($event) {
                        _vm.imageCropperData.fileOrigin = null
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.thumbnailSelector.media && _vm.thumbnailSelector.media.file
        ? _c(
            "portal",
            { attrs: { to: "dash" } },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c("ThumbnailSelector", {
                    attrs: {
                      videoSrc: _vm.thumbnailSelector.media.file.url,
                      videoType: _vm.thumbnailSelector.media.file.info.type,
                      initialTimestampMs:
                        (_vm.thumbnailSelector.media.imagePreview &&
                          _vm.thumbnailSelector.media.imagePreview.timestamp) ||
                        0,
                    },
                    on: {
                      confirmUpload: (file) => _vm.onThumbnailUpload({ file }),
                      confirmFrame: _vm.onThumbnailUpload,
                      clickOutside: function ($event) {
                        _vm.thumbnailSelector.media = null
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }